<template>
  <div v-if="disabled"></div>
  <img
    v-else
    :src="currentSrc"
    :alt="alt"
    :class="{ disabled: disabled }"
    @error="onError"
  />
</template>

<script>
const DEFAULT_IMAGE = "/icons/default-item.jpg";

export default {
  name: "ProductImage",
  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSrc: this.src || DEFAULT_IMAGE,
    };
  },
  watch: {
    src(val) {
      this.currentSrc = val || DEFAULT_IMAGE;
    },
  },
  methods: {
    onError() {
      this.currentSrc = DEFAULT_IMAGE;
    },
  },
};
</script>

<style scoped>
img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}

div {
  background-color: #ebebeb;
  width: 40px;
  height: 40px;
  border-radius: 4px;
}
</style>
